/**
 * 참고 : https://github.kakaocorp.com/kakaopage/karina/blob/8dbd615ed75bbc18696fac4633f8e03c0d9deb2c/modules/karina-core/src/main/kotlin/com/kakaopage/karina/model/enums/ReferenceType.kt#L3
 */
export enum ReferenceTypeVo {
  Local = 'local',
  Reference = 'ref',
}
